import React, { useState, useEffect, useRef } from "react";
import 'react-quill/dist/quill.snow.css';
import styles from "../../css/AddTripForm/FormField.module.css";
import CustomFileInput from "./Elements/CustomFileInput";
import MultiCoordinatorPicker from "./MultiCoordinatorPicker";

import ReactQuill from "react-quill";
const FormField = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
  options,
  required = false,
  errorMessage,
  step,
  min,
  dependentValue,
  info,
  predefinedValues,
  unit,
  max,
  pattern,
  title,
  disabled = false,
  coordinators,
  photoLinkName,
  photoSourceName,
  loading
}) => {
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [showValuesPopup, setShowValuesPopup] = useState(false); 
  const infoPopupRef = useRef(null);
  const valuesPopupRef = useRef(null);
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        showInfoPopup &&
        infoPopupRef.current &&
        !infoPopupRef.current.contains(e.target)
      ) {
        setShowInfoPopup(false);
      }
      if (
        showValuesPopup &&
        valuesPopupRef.current &&
        !valuesPopupRef.current.contains(e.target)
      ) {
        setShowValuesPopup(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showInfoPopup, showValuesPopup]);


  const displayValue = type === "disabled" ? dependentValue : value;

const quillModules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],  
    ["link"],
  ],
  clipboard: { matchVisual: false }
};


const quillFormats = [
  "bold", "italic", "underline", "strike",
  "list", "bullet",
  "link",
  "indent"
];


  return (
    <div className={type === "toggle" ? styles.toggleWrapper : styles.formField}>
      <div className={styles.formFieldInner}>
        {type !== "toggle" && (
          <label className={styles.formLabel}>
            <span className={styles.labelText}>
              {label} {required && <span className={styles.requiredAsterisk}>*</span>}
              {info && (
                <span
                  className={styles.infoIcon}
                  onClick={() => setShowInfoPopup(true)}
                >
                  ℹ️
                </span>
              )}
              {predefinedValues && (
                <span
                  className={styles.valuesIcon}
                  onClick={() => setShowValuesPopup(true)}
                >
                  📋
                </span>
              )}
            </span>
          </label>
        )}

        {showInfoPopup && (
          <div className={`${styles.overlay} ${styles.infoOverlay}`}>
            <div ref={infoPopupRef} className={styles.popup}>
              <p>
                {info.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
            </div>
          </div>
        )}

{showValuesPopup && (
  <div className={styles.overlay}>
    <div ref={valuesPopupRef} className={styles.popup}>
      <div className={styles.popupHeader}>
        Kliknij opcję, aby automatycznie skopiować
      </div>

      {predefinedValues.map((val, index) => (
        <div
          key={index}
          className={styles.popupItem}
          onClick={() => {
            onChange(name, val);
            setShowValuesPopup(false);
          }}
        >
          {val}
        </div>
      ))}
    </div>
  </div>
)}

        {type === "textarea" ? (
          <textarea
            name={name}
            value={displayValue || ""}
            onChange={!disabled ? (e) => onChange(name, e.target.value) : undefined}
            placeholder={placeholder}
            className={styles.formTextarea}
            required={required}
            disabled={disabled}
          />
        ) : type === "select" ? (
          <select
            name={name}
            value={displayValue || ""}
            onChange={!disabled ? (e) => onChange(name, e.target.value) : undefined}
            className={styles.formSelect}
            required={required}
            disabled={disabled} // Ustawienie disabled
          >
            {options.map((option) =>
              typeof option === "string" ? (
                <option key={option} value={option}>
                  {option}
                </option>
              ) : (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              )
            )}
          </select>
        ) : type === "file" ? (
          <CustomFileInput
        name={name}
        photoLink={value}
        onChange={onChange}
        label={label}
        photoLinkName={photoLinkName}
        photoSourceName={photoSourceName}
      />
        ) : type === "toggle" ? (
          <div className={styles.toggleWrapper}>
            <span className={styles.toggleLabel}>
              {label}
              {required && <span className={styles.requiredAsterisk}>*</span>}
              {info && (
                <span
                  className={styles.infoIcon}
                  onClick={() => setShowInfoPopup(true)}
                >
                  ℹ️
                </span>
              )}
            </span>
            <label className={styles.toggleSwitch}>
              <input
                type="checkbox"
                name={name}
                checked={value || false}
                onChange={!disabled ? (e) => onChange(name, e.target.checked) : undefined}
                className={styles.toggleInput}
                disabled={disabled} // Ustawienie disabled
              />
              <span className={styles.toggleSlider}></span>
            </label>
          </div>
        ) : type === "number" ? (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="number"
              name={name}
              value={displayValue || ""}
              onChange={!disabled ? (e) => onChange(name, e.target.value) : undefined}
              style={{ flex: "1" }}
              placeholder={placeholder}
              disabled={disabled} // Ustawienie disabled
              className={styles.formInput}
              required={required}
              step={step}
              min={min}
              max={max}
              pattern={pattern}
              title={title}
            />
            {unit && <span>{unit}</span>}
          </div>
        ) : type === "coordinators" ? (
          <MultiCoordinatorPicker
            coordinators={coordinators}
            value={value || []}
            onChange={(selectedIds) => {onChange(selectedIds)}}
            loading={loading}
          />
        ) : (type === "label") ? (<></>)
        : (type === "richtext") ? (
        <div className={styles.richWrapper}>
          <ReactQuill
            theme="snow"
            value={displayValue || ""}
            onChange={(html) => !disabled && onChange(name, html)}  // zwracamy HTML
            modules={quillModules}
            formats={quillFormats}
            placeholder={placeholder}
            readOnly={disabled}
          />
        </div>
      )
        :(
          <input
            type={type}
            name={name}
            value={displayValue || ""}
            onChange={!disabled ? (e) => onChange(name, e.target.value) : undefined}
            placeholder={placeholder}
            className={styles.formInput}
            required={required}
            disabled={disabled}
            pattern={pattern}
            title={title} // Ustawienie disabled
          />
        )}
        {errorMessage && <span className={styles.errorText}>{errorMessage}</span>}
      </div>
    </div>
  );
};

export default FormField;
